import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
import { PartnerNewsAdminSchema } from '../../entities/partner-news/partner-news.schema';
/**
 * Confirm Partner News Image Upload
 * POST /api/v2/admin/partner-news/:id/images/:slot
 *
 * Replaces the picture already in that slot.
 */ export const ConfirmPartnerNewsImageUploadRequestSchema = z.object({
    key: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    fileName: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED)
});
export const ConfirmPartnerNewsImageUploadResponseSchema = z.object({
    data: PartnerNewsAdminSchema
});

//# sourceMappingURL=confirm-partner-news-image-upload.schema.js.map